import CsvImporter from '../components/CsvImporter.jsx';

const MAPPING = {
  'Mr/Ms': 'salutation',
  'First Name': 'first_name',
  'Last Name': 'last_name',
  'Position': 'position',
  'Department': 'department',
  'Division': 'division',
  'Company': 'company',
  'Web site': 'website',
  'Address Line 1': 'address1',
  'Address Line 2': 'address2',
  'City': 'city',
  'State / Province': 'province_state',
  'Zip / Postal Code': 'postal_zip',
  'Phone 1': 'phone_main',
  'Phone 3': 'phone_cell',
  'E-mail Address': 'email1',
  'E-mail Address 2': 'email2',
  'E-mail Address 3': 'email3',
  'Site Number': 'site_number',
  'POS Type': 'pos_type',
  '1. Current Status Of Lead': 'current_status',
  '2. Number In Chain': 'number_in_chain',
  'Install': 'install_date',
  'Last Contact': 'last_contact',
  'Next Contact.1': 'next_contact',
  'Price': 'price',
  'FTP UsernamePassword': 'ftp_credentials',
  'UserName:Password': 'username_password'
};

const DATE_FIELDS = ['install_date', 'last_contact', 'next_contact'];
const NUMERIC_FIELDS = ['price', 'number_in_chain'];
const PREVIEW_COLUMNS = [
  'last_name', 'first_name', 'company', 'site_number', 'pos_type',
  'city', 'province_state', 'phone_main', 'email1', 'install_date', 'current_status'
];

export default function CustomerImport() {
  return (
    <CsvImporter
      title="Import Customers from CSV"
      subtitle="Upload a Maximizer-format CSV. Columns are mapped automatically."
      backTo="/customers"
      backLabel="Back to Customers"
      mapping={MAPPING}
      dateFields={DATE_FIELDS}
      numericFields={NUMERIC_FIELDS}
      previewColumns={PREVIEW_COLUMNS}
      defaults={{ country: 'Canada' }}
      apiPath="/api/customers/bulk-import"
      successCta="View Customers"
      successHint="All rows will be created as customers · country defaults to Canada"
    />
  );
}
